import React from 'react';
import styled from 'styled-components';
import { FiPhone } from 'react-icons/fi';
import { Container } from '../ui';
import WhatsAppIcon from '../icons/WhatsAppIcon';
import { toWhatsAppPhone } from '../../utils/whatsappPhone';
import { actionBase, ink } from './tokens';

const Band = styled.section`
  position: relative;
  overflow: hidden;
  padding: clamp(3.5rem, 7vw, 5.5rem) 0;
  background: ${({ theme }) => ink(theme)};
  color: #fff;

  &::after {
    content: '';
    position: absolute;
    right: -120px;
    top: -120px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    opacity: 0.25;
    pointer-events: none;
  }
`;

const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
`;

const Kicker = styled.p`
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
`;

const Title = styled.h2`
  margin-top: 0.8rem;
  max-width: 22ch;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 600;
  font-size: clamp(1.7rem, 3.4vw, 2.6rem);
  line-height: 1.1;
  letter-spacing: -0.025em;
  color: #fff;
`;

const Text = styled.p`
  margin-top: 0.9rem;
  max-width: 52ch;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.7;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;

  @media (max-width: 480px) {
    width: 100%;
    a { flex: 1 1 100%; }
  }
`;

const Whats = styled.a`
  ${actionBase}
  background: #25d366;
  color: #fff;
  &:hover { background: #1ebe5b; }
`;

const Phone = styled.a`
  ${actionBase}
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  &:hover { border-color: ${({ theme }) => theme.colors.primary}; }
`;

interface Props {
  name: string;
  whatsHref: string | null;
  phone?: string | null;
  onWhatsApp: () => void;
}

const LocationContact: React.FC<Props> = ({ name, whatsHref, phone, onWhatsApp }) => {
  const phoneDigits = toWhatsAppPhone(phone);
  if (!whatsHref && !phoneDigits) return null;
  return (
    <Band aria-labelledby="local-contato">
      <Container>
        <Inner>
          <div>
            <Kicker>{name}</Kicker>
            <Title id="local-contato">Atendimento pelo WhatsApp</Title>
            <Text>Tire dúvidas, peça mais fotos e agende uma visita aos imóveis disponíveis.</Text>
          </div>
          <Actions>
            {whatsHref && (
              <Whats href={whatsHref} target="_blank" rel="noopener noreferrer" onClick={onWhatsApp}>
                <WhatsAppIcon size={19} /> Falar no WhatsApp
              </Whats>
            )}
            {phoneDigits && (
              <Phone href={`tel:+${phoneDigits}`}>
                <FiPhone size={17} /> {phone}
              </Phone>
            )}
          </Actions>
        </Inner>
      </Container>
    </Band>
  );
};

export default LocationContact;
